var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { utilTime } from "../../../utils/utilTime";
import { TextLoca } from "../text/TextLoca";
var RemainingTimeDisplay = /** @class */ (function (_super) {
    __extends(RemainingTimeDisplay, _super);
    function RemainingTimeDisplay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getLongTimeLocaReplacementMap = function (time) {
            return new Map([
                [ReplacementLoca.zero_0, time.d.toString()],
                [ReplacementLoca.one_1, utilNumber.pad(time.h, 2)],
                [ReplacementLoca.two_2, utilNumber.pad(time.m, 2)],
                [ReplacementLoca.three_3, utilNumber.pad(time.s, 2)],
            ]);
        };
        _this.getShortTimeLocaReplacementMap = function (time) {
            return new Map([
                [ReplacementLoca.zero_0, utilNumber.pad(time.h, 2)],
                [ReplacementLoca.one_1, utilNumber.pad(time.m, 2)],
                [ReplacementLoca.two_2, utilNumber.pad(time.s, 2)],
            ]);
        };
        return _this;
    }
    RemainingTimeDisplay.prototype.render = function () {
        var _a = this.props, seconds = _a.seconds, className = _a.className;
        var roundedSeconds = Math.round(seconds);
        var timeFormat = utilTime.secondsToTime(roundedSeconds);
        var idLocaType = IdLoca.timeDisplay_shortTime;
        var locaReplacements = this.getLongTimeLocaReplacementMap(timeFormat);
        if (timeFormat.d > 1) {
            // When formatting as vague, we need to show ceil(days)
            timeFormat.d += 1;
            idLocaType = IdLoca.timeDisplay_longTimeVague;
            // Needs to be reassigned since we change timeFormat.d
            locaReplacements = this.getLongTimeLocaReplacementMap(timeFormat);
        }
        else if (timeFormat.d > 0) {
            idLocaType = IdLoca.timeDisplay_longTimeExact;
        }
        else {
            locaReplacements = this.getShortTimeLocaReplacementMap(timeFormat);
        }
        return React.createElement(TextLoca, { id: idLocaType, replacements: locaReplacements, className: className });
    };
    return RemainingTimeDisplay;
}(React.Component));
export { RemainingTimeDisplay };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/remaining-time-display/RemainingTimeDisplay.tsx
// module id = 254
// module chunks = 3